import React, { Component } from "react";
// import PropTypes from "prop-types";
import styled from "styled-components";
// import Icon from "module-common/Icon";

export default class SeparateGrid extends Component {
  render() {
    return (
      <Wrapper>
        <LiveChat>Live Chat</LiveChat>
        <Line />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
  position: relative;
`;

const LiveChat = styled.div`
  background-color: #ddd;
  padding: 5px 15px;
  border-radius: 30px;
  position: relative;
  z-index: 1;
`;

const Line = styled.div`
  content: "";
  position: absolute;
  border-top: 2px dashed #ddd;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 12px;
`;



// WEBPACK FOOTER //
// ./src/module-common/SeparateGrid.js